  import React, { useState, useEffect } from 'react';
import ColorInit from "../helper/ColorInit";

const ShippingTwo = () => {
    const [shippingData, setShippingData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [expandedSections, setExpandedSections] = useState({
        shipping_page: true,
        turn_time: false,
        shipping_method: false,
        order_tracking: false,
        faq_section: false,
        need_help: false
    });

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchShippingData();
    }, []);

    const fetchShippingData = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/shipping-policy/`, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                throw new Error(`Failed to fetch shipping policy: ${response.status}`);
            }

            const data = await response.json();
            setShippingData(data);
            setLoading(false);
        } catch (err) {
            console.error('Error fetching shipping data:', err);
            setError('Failed to load shipping information');
            setLoading(false);
        }
    };

    const toggleSection = (section) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    const toggleAllSections = (expand) => {
        setExpandedSections({
            shipping_page: expand,
            turn_time: expand,
            shipping_method: expand,
            order_tracking: expand,
            faq_section: expand,
            need_help: expand
        });
    };

    const palette = {
        lightMint: "#C3DCD8",
        softGrey: "#DBD9DA",
        mutedGold: "#C5BD96",
        mutedTeal: "#93B0AC",
        bgWhite: "#F9FAFB",
        bgIce: "#F2F8F6"
    };

    const cardStyle = (expanded, topColor = palette.lightMint) => ({
        backgroundColor: "#FFFFFF",
        borderRadius: "16px",
        marginBottom: "28px",
        border: `2px solid ${palette.softGrey}`,
        boxShadow: "0 4px 20px rgba(138, 127, 141, 0.06)",
        borderTop: `3px solid ${topColor}`,
        overflow: "hidden",
        transition: "all 0.3s ease",
        cursor: "pointer"
    });

    if (loading) return (
        <div style={{ textAlign: "center", padding: "100px", backgroundColor: palette.bgWhite, minHeight: "60vh" }}>
            <p style={{ fontSize: "1.5rem", color: palette.mutedTeal }}>Loading shipping information...</p>
        </div>
    );
    if (error) return (
        <div style={{ textAlign: "center", padding: "100px", backgroundColor: palette.bgWhite, minHeight: "60vh" }}>
            <p style={{ fontSize: "1.5rem", color: "#E6A4B4" }}>{error}</p>
        </div>
    );
    if (!shippingData) return (
        <div style={{ textAlign: "center", padding: "100px", backgroundColor: palette.bgWhite, minHeight: "60vh" }}>
            <p style={{ fontSize: "1.5rem", color: palette.mutedTeal }}>No shipping information available.</p>
        </div>
    );

    const { shipping_page, turn_time, shipping_method, order_tracking, faq_section, need_help } = shippingData;

    return (
        <>
            <ColorInit color={true} />

            <section id="main-content" className="wrapper main-wrapper">
                <div className="shipping-policy" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", backgroundColor: "#FAF9F6" }}>
                    {/* Hero Section */}
                    <section
                        style={{
                            background: "linear-gradient(135deg, #1D2A3A 0%, #2C3E50 100%)",
                            padding: "80px 20px",
                            textAlign: "center",
                            position: "relative",
                            overflow: "hidden",
                            marginBottom: "40px"
                        }}
                    >
                        <div className="hero-glow" style={{
                            position: "absolute",
                            top: "-50%",
                            left: "-20%",
                            width: "140%",
                            height: "200%",
                            background: "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
                            pointerEvents: "none"
                        }}></div>

                        <div style={{ maxWidth: "900px", margin: "0 auto", position: "relative", zIndex: 1 }}>
                            <h1
                                style={{
                                    fontSize: "clamp(2.5rem, 5vw, 3.5rem)",
                                    fontWeight: "800",
                                    marginBottom: "20px",
                                    color: "white",
                                    textShadow: "0 2px 10px rgba(0,0,0,0.1)"
                                }}
                            >
                                {shipping_page?.page_title || "Shipping & Turnaround"}
                            </h1>
                            <p
                                style={{
                                    fontSize: "1.25rem",
                                    color: "white",
                                    opacity: "0.95",
                                    lineHeight: "1.6",
                                    maxWidth: "700px",
                                    margin: "0 auto"
                                }}
                            >
                                Fast, Reliable Delivery You Can Count On
                            </p>
                        </div>
                    </section>

                    <div
                        className="shipping-policy__container"
                        style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 20px" }}
                    >
                        {/* Expand/Collapse All Buttons */}
                        <div style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "12px",
                            marginBottom: "30px",
                            flexWrap: "wrap"
                        }}>
                            <button
                                onClick={() => toggleAllSections(true)}
                                style={{
                                    backgroundColor: palette.lightMint,
                                    color: palette.mutedTeal,
                                    border: "none",
                                    padding: "10px 24px",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    transition: "all 0.3s ease",
                                    boxShadow: "0 4px 12px rgba(195, 220, 216, 0.3)"
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = palette.mutedTeal;
                                    e.currentTarget.style.color = "white";
                                    e.currentTarget.style.transform = "translateY(-2px)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = palette.lightMint;
                                    e.currentTarget.style.color = palette.mutedTeal;
                                    e.currentTarget.style.transform = "translateY(0)";
                                }}
                            >
                                Expand All
                            </button>
                            <button
                                onClick={() => toggleAllSections(false)}
                                style={{
                                    backgroundColor: "white",
                                    color: palette.mutedTeal,
                                    border: `2px solid ${palette.lightMint}`,
                                    padding: "8px 24px",
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    transition: "all 0.3s ease"
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = palette.bgIce;
                                    e.currentTarget.style.transform = "translateY(-2px)";
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = "white";
                                    e.currentTarget.style.transform = "translateY(0)";
                                }}
                            >
                                Collapse All
                            </button>
                        </div>

                        {/* Page Header Section */}
                        {shipping_page && shipping_page.content && (
                            <section style={{ marginBottom: "50px" }}>
                                <div style={{ display: "flex", alignItems: "center", marginBottom: "35px" }}>
                                    <h2 style={{ color: palette.mutedTeal, fontSize: "2.4rem", fontWeight: "700", margin: 0, letterSpacing: "-0.5px" }}>
                                        {shipping_page.page_title || "Shipping Information"}
                                    </h2>
                                </div>

                                <div
                                    style={cardStyle(expandedSections.shipping_page, palette.mutedGold)}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                                        e.currentTarget.style.borderColor = palette.lightMint;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                                        e.currentTarget.style.borderColor = palette.softGrey;
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: palette.bgIce,
                                            padding: "24px 30px",
                                            borderBottom: expandedSections.shipping_page ? `2px solid ${palette.lightMint}` : "none",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                        onClick={() => toggleSection("shipping_page")}
                                    >
                                        <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                                            <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                                                <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.shipping_page ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.shipping_page ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                                            </span>
                                            Production Process
                                        </h3>
                                        <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                                            {expandedSections.shipping_page ? "Hide Info \u2014" : "Show Info +"}
                                        </span>
                                    </div>
                                    <div
                                        style={{ padding: expandedSections.shipping_page ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.shipping_page ? "5000px" : "0", opacity: expandedSections.shipping_page ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                                        dangerouslySetInnerHTML={{ __html: shipping_page.content }}
                                    />
                                </div>
                            </section>
                        )}

                        {/* Standard Turn Time */}
                        {turn_time && turn_time.is_active && (
                            <section style={{ marginBottom: "50px" }}>
                                <div style={{ display: "flex", alignItems: "center", marginBottom: "35px" }}>
                                    <h2 style={{ color: palette.mutedTeal, fontSize: "2.4rem", fontWeight: "700", margin: 0, letterSpacing: "-0.5px" }}>
                                        {turn_time.heading}
                                    </h2>
                                </div>

                                <div
                                    style={cardStyle(expandedSections.turn_time, palette.lightMint)}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                                        e.currentTarget.style.borderColor = palette.lightMint;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                                        e.currentTarget.style.borderColor = palette.softGrey;
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: palette.bgIce,
                                            padding: "24px 30px",
                                            borderBottom: expandedSections.turn_time ? `2px solid ${palette.lightMint}` : "none",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                        onClick={() => toggleSection("turn_time")}
                                    >
                                        <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                                            <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                                                <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.turn_time ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.turn_time ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                                            </span>
                                            Turnaround Standards
                                        </h3>
                                        <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                                            {expandedSections.turn_time ? "Hide Details \u2014" : "Show Details +"}
                                        </span>
                                    </div>
                                    <div
                                        style={{ padding: expandedSections.turn_time ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.turn_time ? "5000px" : "0", opacity: expandedSections.turn_time ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                                        dangerouslySetInnerHTML={{ __html: turn_time.content }}
                                    />
                                </div>
                            </section>
                        )}

                        {/* Shipping Methods */}
                        {shipping_method && shipping_method.is_active && (
                            <section style={{ marginBottom: "50px" }}>
                                <div style={{ display: "flex", alignItems: "center", marginBottom: "35px" }}>
                                    <h2 style={{ color: palette.mutedTeal, fontSize: "2.4rem", fontWeight: "700", margin: 0, letterSpacing: "-0.5px" }}>
                                        {shipping_method.heading}
                                    </h2>
                                </div>

                                <div
                                    style={cardStyle(expandedSections.shipping_method, palette.mutedGold)}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                                        e.currentTarget.style.borderColor = palette.lightMint;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                                        e.currentTarget.style.borderColor = palette.softGrey;
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: palette.bgIce,
                                            padding: "24px 30px",
                                            borderBottom: expandedSections.shipping_method ? `2px solid ${palette.lightMint}` : "none",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                        onClick={() => toggleSection("shipping_method")}
                                    >
                                        <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                                            <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                                                <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.shipping_method ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.shipping_method ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                                            </span>
                                            Shipping Options
                                        </h3>
                                        <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                                            {expandedSections.shipping_method ? "Hide Options \u2014" : "Show Options +"}
                                        </span>
                                    </div>
                                    <div
                                        style={{ padding: expandedSections.shipping_method ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.shipping_method ? "5000px" : "0", opacity: expandedSections.shipping_method ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                                        dangerouslySetInnerHTML={{ __html: shipping_method.content }}
                                    />
                                </div>
                            </section>
                        )}

                        {/* Order Tracking */}
                        {order_tracking && order_tracking.is_active && (
                            <section style={{ marginBottom: "50px" }}>
                                <div style={{ display: "flex", alignItems: "center", marginBottom: "35px" }}>
                                    <h2 style={{ color: palette.mutedTeal, fontSize: "2.4rem", fontWeight: "700", margin: 0, letterSpacing: "-0.5px" }}>
                                        {order_tracking.heading}
                                    </h2>
                                </div>

                                <div
                                    style={cardStyle(expandedSections.order_tracking, palette.softGrey)}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                                        e.currentTarget.style.borderColor = palette.lightMint;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                                        e.currentTarget.style.borderColor = palette.softGrey;
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: palette.bgIce,
                                            padding: "24px 30px",
                                            borderBottom: expandedSections.order_tracking ? `2px solid ${palette.lightMint}` : "none",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                        onClick={() => toggleSection("order_tracking")}
                                    >
                                        <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                                            <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                                                <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.order_tracking ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.order_tracking ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                                            </span>
                                            Delivery Tracking
                                        </h3>
                                        <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                                            {expandedSections.order_tracking ? "Hide Tracking \u2014" : "Show Tracking +"}
                                        </span>
                                    </div>
                                    <div
                                        style={{ padding: expandedSections.order_tracking ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.order_tracking ? "5000px" : "0", opacity: expandedSections.order_tracking ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                                        dangerouslySetInnerHTML={{ __html: order_tracking.content }}
                                    />
                                </div>
                            </section>
                        )}

                        {/* FAQ Section */}
                        {faq_section && faq_section.is_active && (
                            <section style={{ marginBottom: "50px" }}>
                                <div style={{ display: "flex", alignItems: "center", marginBottom: "35px" }}>
                                    <h2 style={{ color: palette.mutedTeal, fontSize: "2.4rem", fontWeight: "700", margin: 0, letterSpacing: "-0.5px" }}>
                                        {faq_section.heading}
                                    </h2>
                                </div>

                                <div
                                    style={cardStyle(expandedSections.faq_section, palette.mutedGold)}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                                        e.currentTarget.style.borderColor = palette.lightMint;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                                        e.currentTarget.style.borderColor = palette.softGrey;
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: palette.bgIce,
                                            padding: "24px 30px",
                                            borderBottom: expandedSections.faq_section ? `2px solid ${palette.lightMint}` : "none",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                        onClick={() => toggleSection("faq_section")}
                                    >
                                        <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                                            <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                                                <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.faq_section ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.faq_section ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                                            </span>
                                            Global FAQ
                                        </h3>
                                        <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                                            {expandedSections.faq_section ? "Hide FAQ \u2014" : "Show FAQ +"}
                                        </span>
                                    </div>
                                    <div
                                        style={{ padding: expandedSections.faq_section ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.faq_section ? "5000px" : "0", opacity: expandedSections.faq_section ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                                    >
                                        {faq_section.subheading && (
                                            <p style={{ marginBottom: "20px", fontSize: "1.1rem", color: palette.mutedTeal, fontWeight: "600" }}>
                                                {faq_section.subheading}
                                            </p>
                                        )}
                                        <div dangerouslySetInnerHTML={{ __html: faq_section.content }} />
                                    </div>
                                </div>
                            </section>
                        )}

                        {/* Need Help Section */}
                        {need_help && need_help.is_active && (
                            <section style={{ marginBottom: "80px" }}>
                                <div style={{ display: "flex", alignItems: "center", marginBottom: "35px" }}>
                                    <h2 style={{ color: palette.mutedTeal, fontSize: "2.4rem", fontWeight: "700", margin: 0, letterSpacing: "-0.5px" }}>
                                        Need Assistance?
                                    </h2>
                                </div>

                                <div
                                    style={cardStyle(expandedSections.need_help, palette.lightMint)}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.boxShadow = "0 8px 30px rgba(147, 176, 172, 0.15)";
                                        e.currentTarget.style.borderColor = palette.lightMint;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.boxShadow = "0 4px 20px rgba(138, 127, 141, 0.06)";
                                        e.currentTarget.style.borderColor = palette.softGrey;
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: palette.bgIce,
                                            padding: "24px 30px",
                                            borderBottom: expandedSections.need_help ? `2px solid ${palette.lightMint}` : "none",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center"
                                        }}
                                        onClick={() => toggleSection("need_help")}
                                    >
                                        <h3 style={{ color: palette.mutedTeal, margin: "0", fontSize: "1.5rem", fontWeight: "600", display: "flex", alignItems: "center", gap: "15px" }}>
                                            <span style={{ width: "32px", height: "32px", borderRadius: "50%", backgroundColor: palette.lightMint, display: "flex", alignItems: "center", justifyContent: "center", position: "relative" }}>
                                                <span style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", width: "0", height: "0", borderLeft: "6px solid transparent", borderRight: "6px solid transparent", borderTop: expandedSections.need_help ? "0" : `6px solid ${palette.mutedTeal}`, borderBottom: expandedSections.need_help ? `6px solid ${palette.mutedTeal}` : "0", transition: "all 0.3s ease" }}></span>
                                            </span>
                                            Support Center
                                        </h3>
                                        <span style={{ color: palette.mutedTeal, fontWeight: "600", fontSize: "14px", textTransform: "uppercase", letterSpacing: "1px" }}>
                                            {expandedSections.need_help ? "Hide Support \u2014" : "Show Support +"}
                                        </span>
                                    </div>
                                    <div
                                        style={{ padding: expandedSections.need_help ? "32px" : "0", color: "#4B5563", lineHeight: "1.8", backgroundColor: "#FFFFFF", maxHeight: expandedSections.need_help ? "5000px" : "0", opacity: expandedSections.need_help ? "1" : "0", overflow: "hidden", transition: "all 0.5s ease" }}
                                    >
                                        <div dangerouslySetInnerHTML={{ __html: need_help.content }} />
                                        {need_help.email && (
                                            <p style={{ marginTop: "24px", paddingTop: "24px", borderTop: `2px solid ${palette.bgIce}`, fontSize: "1rem", color: "#4B5563" }}>
                                                Contact us at <b><a href={`mailto:${need_help.email}`} style={{ color: palette.mutedTeal, textDecoration: "none", borderBottom: `2px solid ${palette.lightMint}`, paddingBottom: "2px", transition: "all 0.3s ease" }} onMouseEnter={(e) => e.currentTarget.style.color = palette.mutedGold} onMouseLeave={(e) => e.currentTarget.style.color = palette.mutedTeal}>{need_help.email}</a></b>. We're here to help!
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </section>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

export default ShippingTwo;